import apiClient from '@/utils/httpClient';
import { DateFilterKey, resolveDateFilter } from '@/utils/dateFilters';
import { format } from 'date-fns';

export interface InvoiceExportFilters {
  customers?: string[];
  statuses?: string[];
  overdueOnly?: boolean;
  dateFilterKey: DateFilterKey | '';
  dateCustomFrom?: Date;
  dateCustomTo?: Date;
  amountMin?: string;
  amountMax?: string;
}

export interface ExpenseExportFilters {
  vendors?: string[];
  sourceTypes?: string[];
  statuses?: string[];
  categories?: string[];
  showOverdue?: boolean;
  dateFilterKey: DateFilterKey | '';
  dateCustomFrom?: Date;
  dateCustomTo?: Date;
  amountMin?: string;
  amountMax?: string;
}

export async function exportInvoicesCsv(filters: InvoiceExportFilters): Promise<void> {
  const params: Record<string, string> = {};
  if (filters.customers?.length) params['customer'] = filters.customers.join(',');
  if (filters.statuses?.length) params['status'] = filters.statuses.join(',');
  if (filters.overdueOnly) params['overdueOnly'] = 'true';
  const resolved = resolveDateFilter(filters.dateFilterKey, filters.dateCustomFrom, filters.dateCustomTo);
  if (resolved) { params['dateFrom'] = resolved.startDate; params['dateTo'] = resolved.endDate; }
  if (filters.amountMin) params['amountMin'] = filters.amountMin;
  if (filters.amountMax) params['amountMax'] = filters.amountMax;

  const today = format(new Date(), 'yyyy-MM-dd');
  await apiClient.download('/invoices/export-csv', `invoices-${today}.csv`, params);
}

export async function exportExpensesCsv(filters: ExpenseExportFilters): Promise<void> {
  const params: Record<string, string> = {};
  if (filters.vendors?.length) params['vendor'] = filters.vendors.join(',');
  if (filters.sourceTypes?.length) params['sourceType'] = filters.sourceTypes.join(',');
  if (filters.statuses?.length) params['status'] = filters.statuses.join(',');
  if (filters.categories?.length) params['category'] = filters.categories.join(',');
  if (filters.showOverdue) params['overdue'] = 'true';
  const resolved = resolveDateFilter(filters.dateFilterKey, filters.dateCustomFrom, filters.dateCustomTo);
  if (resolved) { params['dateFrom'] = resolved.startDate; params['dateTo'] = resolved.endDate; }
  if (filters.amountMin) params['amountMin'] = filters.amountMin;
  if (filters.amountMax) params['amountMax'] = filters.amountMax;

  const today = format(new Date(), 'yyyy-MM-dd');
  await apiClient.download('/expenses-payable/export-csv', `expenses-${today}.csv`, params);
}
